// Composable that enables a redirect to an error page with route params/queries

import { useRouter } from 'vue-router';

interface IErrorRedirectParams {
  code?: string;
  title: string;
  body?: string;
}

/**
 * A Vue composable that provides error redirection functionalities.
 *
 * @function
 * @name useHErrorRedirect
 * @description
 * This composable provides a method to redirect to an error route with specified query parameters.
 *
 * @returns {Function} A function that redirects to the specified error route.
 * @param {IErrorRedirectParams} errorRedirectParams - The parameters to include in the query string of the error route.
 * @param {string} [routeName='error'] - The name of the error route to redirect to. Defaults to 'error'.
 */
export function useHErrorRedirect() {
  const router = useRouter();

  return function (errorRedirectParams: IErrorRedirectParams, routeName: string = 'error') {
    router.push({ name: routeName, query: { ...errorRedirectParams } });
  };
}
